import classNames from 'classnames'
import React, { ReactNode } from 'react'
import styles from './FormSelectHeaderItem.module.css'

interface Props extends React.LiHTMLAttributes<HTMLLIElement> {
  children: ReactNode
}

export const FormSelectHeaderItem = ({ children, className, ...props }: Props) => {
  return (
    <li className={classNames(styles.li, className)} {...props}>
      {children}
    </li>
  )
}
